import AppRouter from 'common/AppRouter';
import Text, { Inline } from 'components/base/Text';
import { Link } from 'react-router-dom';

const RevokeTokenTooltip = ({ organizationSettings, repositoriesName }) => {
  let text;

  if (organizationSettings) {
    return (
      <div>
        <Text size='large' mt='10px'>
          Revoke Token
        </Text>
        <Text color='gray' size='large' mt='8px' pb='10px' width='250px'>
          API token in use -<br />
          select a different detection strategy
          <br />
          before attempting revoke
          <br />
          <br />
          Go to{' '}
          <Link
            to={AppRouter.CONFIGURATION.path}
            style={{ textDecoration: 'none' }}
          >
            <Inline size='large' color='chambray'>
              {' '}
              Settings
            </Inline>{' '}
            /{' '}
            <Inline size='large' color='chambray'>
              {' '}
              Advanced
            </Inline>
          </Link>
        </Text>
      </div>
    );
  } else if (repositoriesName.length) {
    text = `This token is used for the repositor${
      repositoriesName.length > 1 ? 'ies' : 'y'
    }:<br />${repositoriesName.join('<br />')}`;
    return <Text dangerouslySetInnerHTML={{ __html: text }} />;
  }
};

export default RevokeTokenTooltip;
